import React, { PureComponent } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { Button, Cell, DataTable, DialogContainer, Grid, TableBody, TableColumn, TableHeader, TableRow, TextField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import { BeatLoader } from 'react-spinners';
import styles from '../css/styles.css.js';
import crossIcon from '../images/png/crossIcon.png';
import editIcon from '../images/png/edit.png';
import HelpText from '../lib/help-text';




export default class HelpTextTable extends PureComponent  {
    helpText = new HelpText();

    constructor(props){
        super(props);
        this.state = {
            helpTextMap:undefined,
            currentHelpItem:undefined,
            createMode:false,
            loading:false
        };
    }

    componentWillMount(){
        const getHelpTextPromise = this.helpText.getAllHelpText(true);

        getHelpTextPromise.then(helpTextMap =>{
            
            this.setState({helpTextMap});
            
        })

        getHelpTextPromise.catch(err =>{
            NotificationManager.error(err, 'ERROR', 3000);
        });
    }

    //Dialog Code
    addHelpTextDialog = () =>{
        let currentHelpItem = {
            key:'',
            help_text:''
        };
        this.setState({currentHelpItem,showHelpEditDialog:true,createMode:true});

    }

    onHelpTextEditClicked = (helpItem) =>{
        this.setState({
                        currentHelpItem:helpItem,
                        showHelpEditDialog:true,
                        createMode:false
                    })
    }

    onHelpTextDialogClose = () =>{
        this.setState({showHelpEditDialog:false});
    }
    
    onHextTextSave = () =>{
        this.setState({loading:true});
        const savePromise = this.helpText.saveHelpTextItem(this.state.currentHelpItem);
        savePromise.then(helpTextMap =>{
            this.setState({helpTextMap,showHelpEditDialog:false});
        });

        savePromise.catch(err =>{
            NotificationManager.error(err, 'ERROR', 3000);
        });

        savePromise.finally(()=> {
            this.setState({loading:false});
        });

    }

    onHelpTextDelete = (helpTextItem) => {
        confirmAlert({
            title: 'Are you sure want to delete this Help? ',
            message: 'Press Confirm to submit',
            cancelLabel: 'Confirm',
            confirmLabel: 'Cancel',
            onCancel: () => {
                this.setState({loading:true});
                const deletePromise = this.helpText.deleteHelpTextItem(helpTextItem);

                deletePromise.then(helpTextMap =>{
                    this.setState({helpTextMap});
                    this.forceUpdate();
                });
        
                deletePromise.catch(err =>{
                    NotificationManager.error(err, 'ERROR', 3000);
                });

                deletePromise.finally(()=> {
                    this.setState({loading:false});
                });
            }
          })       
    }

    onHelpTextDialogDataChange = (helpItem) => {
        console.log('helpItem',helpItem);
        this.setState({
            currentHelpItem:helpItem
        })
    }
    

    render(){
        if(this.state.loading)
        {
            return <BeatLoader color='#bb0000' loading={this.state.loading} size={10} />
        }
        return [<Grid key="helpTextTable">
                    <Cell size={12} className="semester-title">
                        <h3>Assignment Creation Page - Help Text</h3>
                        <Button className="archive-button" primary raised 
                        onClick={this.addHelpTextDialog}>
                            Add a New a Help Text
                        </Button>
                    </Cell>
                    <Cell size={12}  className="semester-table-container">
                        <HelpTextDataTable onEditClick={this.onHelpTextEditClicked} onDeleteClick={this.onHelpTextDelete} helpTextMap={this.state.helpTextMap} ></HelpTextDataTable>
                    </Cell>
                </Grid>,
                <EditHelpDialog 
                    allowKeyEdit={this.state.createMode}
                    helpItem={this.state.currentHelpItem} 
                    visible={this.state.showHelpEditDialog} 
                    hideDialog={this.onHelpTextDialogClose}
                    onSave={this.onHextTextSave}
                    onChange = {this.onHelpTextDialogDataChange}/>
                ]
    }
}




var HelpTextDataTable = (props) => {

    
    if(props.helpTextMap){
        return <DataTable plain>
            <TableHeader>
                <TableRow>    
                    <TableColumn>Field Name</TableColumn>
                    <TableColumn>Help text</TableColumn>
                    <TableColumn>Actions</TableColumn>
                </TableRow>
            </TableHeader>
            <TableBody>
                {Object.values(props.helpTextMap).map((helpText, _) => (
                    <TableRow key={helpText.key}>
                        <TableColumn>{helpText.key}</TableColumn>
                        <TableColumn>{helpText.help_text}</TableColumn>
                        <TableColumn>
                            <Button icon tooltipLabel="Edit" onClick={() => props.onEditClick(helpText)}>
                                <img src={editIcon} alt="Edit"  />
                            </Button>
                            <Button icon tooltipLabel="Delete" onClick={() => props.onDeleteClick(helpText)}>
                                <img src={crossIcon} alt="Delete"  />
                            </Button>
                        </TableColumn>
                    </TableRow>
                ))} 
            </TableBody>
        </DataTable>
    }
    

    return null;
}


var EditHelpDialog = (props) =>{
    let saveButton = <Button style= {styles.addButton} onClick = {props.onSave}>Save</Button>;
    var cancelButton = <Button style= {styles.cancelButton} onClick = {props.hideDialog}>Cancel</Button>
    
    const actions = [];
    actions.push(saveButton);
    actions.push(cancelButton);

    const onChange = (key,value) =>{
        let curHelpItem = {};
        Object.assign(curHelpItem, props.helpItem);
        curHelpItem[key] = value;
        props.onChange(curHelpItem);
    }

    if(props.helpItem === undefined || props.helpItem === null){
        return null;
    }

    return <DialogContainer
                id="help-text-dialog"
                visible={props.visible}
                onHide={props.hideDialog}
                actions={actions}
                width="500px"
                key="AddDialog"
                title="Add/Edit Help"
                contentClassName="md-grid"
                >
                    <TextField 
                        value={props.helpItem.key} 
                        onChange={value=>onChange('key',value)} 
                        id="key-id" label="Field Name" 
                        placeholder="Enter the name of the Field you want to add Help content here..." 
                        className="md-cell md-cell--12" 
                        required
                        disabled={!props.allowKeyEdit} 
                    />
                    <TextField 
                        value={props.helpItem.help_text} 
                        onChange={value=>onChange('help_text',value)} 
                        id="help-text-id" 
                        label="Help Text" 
                        placeholder="Enter the Help content for the Field here..." 
                        rows={2} 
                        className="md-cell md-cell--12" 
                    />
            </DialogContainer>
}
